// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "12e42f71143cc907b4ff02328ae310256eb3a7fc/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"41":"de5ada12","440":"486bdddc","581":"a474c96c","788":"955d0193","804":"1cf18fe1","810":"5b7541cc"}[chunkId] + ".chunk.js";
};